import React, { memo } from 'react'
import { useHistory } from 'react-router-dom'
import { Button } from 'transfix-ui/components/Button'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { SearchIcon, AddIcon } from 'transfix-icons'

interface INoLoadsProps {
  isFilteredView?: boolean
  onAddLoadClick: () => void
  clearFiltersHandler: () => void
}

export const NoLoads = memo<INoLoadsProps>(
  ({ clearFiltersHandler, isFilteredView, onAddLoadClick }) => {
    const { isMobile } = useBreakpointContext()
    const history = useHistory()

    const loadsToBook = () => {
      history.push('/book')
    }

    return (
      <div className='tc pa3'>
        <div className='pv4'>
          {isFilteredView ? (
            <div className='body-medium'>
              No loads to show in this tab.
              <div className='mt1'>
                <span className='text-secondary'>Refine your search or</span>
                <span className='ml1'>
                  <Button
                    className='btn-text-link-b'
                    onClick={clearFiltersHandler}
                    data-test='loads-list-no-load-clear-all-filters-btn'>
                    clear your filters
                  </Button>
                </span>
              </div>
            </div>
          ) : (
            <div className='body-medium'>
              You don’t have loads yet
              <div className='mt1'>
                <span className='text-secondary'>
                  Search for and book new loads or add your own loads.
                </span>
                <div className='mt3'>
                  <Button
                    size='large'
                    color='primary'
                    onClick={loadsToBook}
                    startIcon={<SearchIcon />}>
                    Search for Loads to Book
                  </Button>
                  <Button
                    size='large'
                    color='secondary'
                    onClick={onAddLoadClick}
                    startIcon={<AddIcon />}
                    className={isMobile ? 'mt4' : 'ml4'}>
                    Add Your Own Load
                  </Button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
)
